export default "__VITE_ASSET__7d8e8d82__"